// Small localStorage helpers for the offline till. Everything is scoped to the
// logged-in cashier (the `sub` of the login token) so a till that switches
// store never reads another store's catalogue, cart or queued sales.

export const userScope = () => {
  try {
    const token = sessionStorage.getItem("cashier_token");
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload)).sub || "anon";
  } catch {
    return "anon";
  }
};

const fullKey = (key) => `01pos_offline:${userScope()}:${key}`;

export const readJson = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(fullKey(key));
    return raw == null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeJson = (key, value) => {
  try {
    localStorage.setItem(fullKey(key), JSON.stringify(value));
    return true;
  } catch {
    // Quota exceeded or storage blocked: the app keeps working online.
    return false;
  }
};

export const removeKey = (key) => {
  try {
    localStorage.removeItem(fullKey(key));
  } catch {
    // ignore
  }
};

// Keys (without the scope prefix) that start with `prefix`.
export const listKeys = (prefix) => {
  const scoped = fullKey("");
  const keys = [];
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(scoped + prefix)) keys.push(k.slice(scoped.length));
    }
  } catch {
    // ignore
  }
  return keys;
};

// True when the request never reached the server (no connection, DNS, CORS
// preflight blocked by a dead network) or timed out. A timeout on a sale with
// no client_ref is deliberately NOT a network error: the server may have
// processed it and a replay could double-charge.
export const isNetworkError = (error) => {
  if (!error) return false;
  if (error.isNetworkError === true) return true;
  if (error.response) return false;
  if (error.code === "ERR_NETWORK") return true;
  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
    const url = String(error.config?.url || "");
    if (!url.includes("orders/store")) return true;
    try {
      return !!JSON.parse(error.config?.data || "{}").client_ref;
    } catch {
      return false;
    }
  }
  return false;
};

export const newRef = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
